<style>
	:global(.sv_complete_btn) {
		display: none;
	}
</style>

<script>
	import Card from '@smui/card';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import HorizontalFieldsLoading from '../../../..//shared/components/common/Loading/HorizontalFieldsLoading.svelte';
	import SurveyLoading from '../../../..//shared/components/common/Loading/SurveyLoading.svelte';
	import Survey from '../../../..//shared/components/common/Survey/Survey.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import QuestionarioRisposte from '../../../../shared/models/Questionario/QuestionarioRisposte';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = QuestionarioRisposte.get(params.id);
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.survey.detail.title_answers')}" />
	</div>
	{#if $loading}
		<HorizontalFieldsLoading />
		<div class="md:col-start-1 md:col-end-5 pt-4">
			<SurveyLoading />
		</div>
	{:else}
		<form id="form" class="md:grid-cols-1 lg:grid-cols-3 md:gap-x-8 md:px-4 grid grid-cols-1 pt-4">
			<!--
			<Input disabled label="{$_('page.survey.detail.code')}" bind:value="{$data.codice}" />
			-->
			<Input disabled label="{$_('page.survey.detail.description')}" bind:value="{$data.descrizione}" />
			<Input disabled label="{$_('page.survey.detail.start_validity')}" bind:value="{$data.dataInizioValidita}" type="datetime-local" />
			<Input disabled label="{$_('page.survey.detail.end_validity')}" bind:value="{$data.dataFineValidita}" type="datetime-local" />
			<div class="md:col-start-1 md:col-end-5 pt-4">
				<Survey bind:stringifiedJson="{$data.questionario.questionarioJson}" bind:stringifiedData="{$data.questionarioRisposteJson}" mode="display"/>
			</div>
		</form>
	{/if}
</Card>
